import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export interface DropIndicatorTarget {
    /** Full droppable id under the cursor, e.g. "test_blocks_0" or "test_blocks_3_pageKey". */
    droppableId: string;
    /** Local insertion index within that droppable (from dnd's DragUpdate). */
    index: number;
    /** Height (px) of the gap the drag opens — the dragged item's measured height. */
    height: number;
    /**
     * Set while the cursor sits outside every droppable — the paper gap
     * between two pages. dnd has snapped the neighbours back, so there is no
     * gap to fill: the indicator collapses to a rule on the last real edge
     * instead of painting a slot over a block that never moved.
     */
    pending?: boolean;
}

const DropIndicatorContext = createContext<DropIndicatorTarget | null>(null);

/** Read-only access to the active drop target. State is owned by the drag host. */
// eslint-disable-next-line react-refresh/only-export-components
export const useDropIndicator = () => useContext(DropIndicatorContext);

export function DropIndicatorProvider({
    value,
    children,
}: {
    value: DropIndicatorTarget | null;
    children: ReactNode;
}) {
    return <DropIndicatorContext.Provider value={value}>{children}</DropIndicatorContext.Provider>;
}
